import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthContextProvider } from "./app/context/AuthContext";
import { Provider } from "react-redux";
import store from "./redux/store";
import { CharacterProvider } from "./app/context/CharacterContext";
import { NotificationProvider } from "./app/context/notificationContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthContextProvider>
        <CharacterProvider>
          <NotificationProvider>
          <App />
          </NotificationProvider>
        </CharacterProvider>
      </AuthContextProvider>
    </Provider>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
